// angular
import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class NoIndexService {
  constructor(@Inject(DOCUMENT) private _dom: any) {}

  public setNoindexMetaTag() {
    const meta: HTMLMetaElement = this._dom.createElement('meta');
    meta.setAttribute('name', 'content');
    this._dom.head.appendChild(meta);
    meta.setAttribute('name', 'robots');
    meta.setAttribute('content', 'noindex');
  }
}
